import { render } from "./ScheduleRecallModal.vue?vue&type=template&id=4b178770"
import script from "./ScheduleRecallModal.vue?vue&type=script&lang=js"
export * from "./ScheduleRecallModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__